export default __webpack_public_path__ + "2a56f6b56e1fe4b571c2cc86a2606296.svg";